export const getScrollbarSize = (el) => {
    const width = el.offsetWidth - el.clientWidth
    const height = el.offsetHeight - el.clientHeight
    return {width, height}
}

